import { useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { NavContext } from '../../../context/global_context'
import { getVehicleRedirectUrl } from '../../../utils/common'
import VisualAidtore from '../../../components/vehicle/visual_aid/context/context'
import VisualAid from '../../../components/vehicle/visual_aid'

const VisualAidPage = () => {
  const { vehicle } = useParams()

  const [navState, navDispatch] = useContext(NavContext)

  useEffect(() => {
    navDispatch({
      type: 'header',
      data: {
        header: vehicle,
        sub_header: 'You can manage visual aid configuration from here.',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: getVehicleRedirectUrl(),
        full_width_container: false,
      },
    })
  }, [])

  return (
    <VisualAidtore>
      <VisualAid />
    </VisualAidtore>
  )
}

export default VisualAidPage
